import { differenceInHours, parseISO } from "date-fns";
import { FocusEventHandler } from "react";
import { required, SelectInput, useTranslate } from "react-admin";
import { IDropDownAppData } from "../../../common/redux/reducers/appDataReducer";
import { useForm } from "react-final-form";
import { DateTimePicker } from "../../common/form/DateTimePicker/DateTimePicker";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";

interface Props {
  defaultTime: string;
  eventTypeCodes: Array<IDropDownAppData<string>>;
  timeZone?: string;
  isEdit?: boolean;
}

export const EventStatusAndTimePicker = (props: Props) => {
  const { timeZone, defaultTime, isEdit, eventTypeCodes, ...rest } = props;
  const form = useForm();
  const translate = useTranslate();

  const handlePickerFocus: FocusEventHandler = (e) => {
    const value = form.getFieldState("startTime")?.value;
    if (value) {
      return;
    }

    let initialTime = new Date();
    let time = parseISO(defaultTime);

    if (form.getFieldState("eventTypeCode")?.value === "VehicleStartOfDay") {
      form.change("startTime", time);
      return;
    }

    const diff = differenceInHours(initialTime, time);
    if (diff >= 24) {
      initialTime = time;
    }

    form.change("startTime", initialTime);
  };

  const checkAllowedRange = (value?: number | string, values?: any) => {
    if (!value) {
      return undefined;
    }

    let dateToCheck: Date;
    if (isNaN(Number(value))) {
      dateToCheck = parseISO(`${value}`);
    } else {
      dateToCheck = new Date(value);
    }

    if (dateToCheck > new Date()) {
      return translate("resources.common.labels.futureTimeNotAllowed");
    }
  };

  return (
    <div className="two-inputs-container">
      <SelectInput
        {...rest}
        source="eventTypeCode"
        label="Status event type"
        choices={eventTypeCodes}
        validate={required()}
      />
      <GenericDateOrTimePicker
        {...props}
        PickerComponent={DateTimePicker}
        source="startTime"
        label="Time"
        validate={[required(), checkAllowedRange]}
        disabled={isEdit}
        options={{ views: ["hours", "minutes", "seconds"] }}
        timeZone={timeZone}
        onFocus={handlePickerFocus}
      />
    </div>
  );
};
